module.exports = __webpack_public_path__ + "img/icon-track-white.83073bd8.svg";